<template>
  <div>
    <v-row no-gutters>
      <h2>Approval Dashboard</h2>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="pt-7" no-gutters>
      <ApprovalNestedNavigation />
    </v-row>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import ApprovalNestedNavigation from './ApprovalNestedNavigation';
export default {
  components: {
    ApprovalNestedNavigation
  },
  props: ['title'],
};
</script>

<style></style>
